import { isBefore, addHours, startOfDay } from 'date-fns';
import { de, enGB, enUS, es, fr, frCA, id, it, ja, ko, ptBR, ru, tr, zhCN, zhTW } from 'date-fns/locale';

function isBeforeNoon(date) {
  var noon = addHours(startOfDay(date), 12);
  return isBefore(date, noon);
}
function cloneDate(date) {
  return new Date(date.getTime());
}
function getDateFormat(locale) {
  switch (locale === null || locale === void 0 ? void 0 : locale.code) {
    case "de":
      return "dd.MM.yyyy";

    case "en-GB":
      return "dd MMM yyyy";

    case "en-US":
      return "MMM dd, yyyy";

    case "es":
      return "dd MMM yyyy";

    case "fr":
      return "dd MMM yyyy";

    case "fr-CA":
      return "dd MMM yyyy";

    case "id":
      return "dd/MM/yyyy";

    case "it":
      return "dd MMM yyyy";

    case "ja":
      return "yyyy/MM/dd";

    case "ko":
      return "yyyy. M. dd.";

    case "pt-BR":
      return "dd/MM/yyyy";

    case "ru":
      return "d.MM.yyyy";

    case "tr":
      return "dd.MM.yyyy";

    case "zh-CN":
      return "yyyy\u5E74MMMdo";

    case "zh-TW":
      return "yyyy\u5E74MMMdo";

    default:
      return "PP";
  }
}
var dateFnsLocaleMap = {
  "de-DE": de,
  "en-GB": enGB,
  "en-US": enUS,
  "es-ES": es,
  "fr-FR": fr,
  "fr-CA": frCA,
  "id-ID": id,
  "it-IT": it,
  "ja-JP": ja,
  "ko-KR": ko,
  "pt-BR": ptBR,
  "ru-RU": ru,
  "tr-TR": tr,
  "zh-CN": zhCN,
  "zh-TW": zhTW
};

export { cloneDate, dateFnsLocaleMap, getDateFormat, isBeforeNoon };
